<template>
  <table border="1">
    <tr>
      <th>Threshold</th>
      <th>Percentage</th>
    </tr>
    <tr v-for="scalePercentageItem in scalePercentageItems" :key="scalePercentageItem.id">
      <td>{{ scalePercentageItem.threshold | toCurrency }}</td>
      <td>{{ scalePercentageItem.percentage }}</td>
    </tr>
  </table>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "ScaleLitePercentage",
  props: ["id"],
  data() {
    return {
      scalePercentageItems: null
    };
  },
  methods: {
    fetchScaleItems() {
      nbmlaw
        .get(
          `/cors/admin/sales/scalePercentages/${this.id}/scalePercentageItems`
        )
        .then(response => {
          // console.log(response.data);
          this.scalePercentageItems = response.data;
        })
        .catch(() => {});
    }
  },
  watch: {
    id: {
      immediate: true,
      handler() {
        this.fetchScaleItems();
      }
    }
  }
};
</script>